exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".m-dropdown-wrapper{position:absolute;z-index:10;right:calc(-50% + 25px)}.m-dropdown-wrapper.is-top{bottom:calc(100% - 10px)}.dropdown-wrapper-right{position:relative;float:right}.dropdown-wrapper-right .m-dropdown-wrapper{right:0}", ""]);

// exports
